import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

// Cubic-bezier easing, typed as a 4-tuple so it satisfies Framer's Easing type.
const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

type RevealProps = {
  children: ReactNode;
  className?: string;
  /** Stagger delay in seconds */
  delay?: number;
};

/**
 * Deliberate, weighted scroll-reveal: content rises a touch and fades in once,
 * when it enters the viewport. Honors prefers-reduced-motion (renders static).
 */
export function Reveal({ children, className, delay = 0 }: RevealProps) {
  const reduce = useReducedMotion();

  if (reduce) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.8, ease: EASE_OUT, delay }}
    >
      {children}
    </motion.div>
  );
}
